import script from "./dynamic-table.vue?vue&type=script&setup=true&lang=js"
export * from "./dynamic-table.vue?vue&type=script&setup=true&lang=js"

import "./dynamic-table.vue?vue&type=style&index=0&id=9467d780&lang=css"

const __exports__ = script;

export default __exports__